import type { ItemPriceResultDto, ProductPublicDto } from "@sticker-giant/sg-frontend-common";
import { useQuery } from "@tanstack/react-query";
import { buildStartingPriceRequest } from "@/lib/product/pricing";
import { usePdpParams } from "@/providers/PdpParamsProvider";
import { usePdpStore } from "@/stores/usePdpStore";
import { useServicesStore } from "@/stores/useServicesStore";
export const useStartingPrice = (product?: ProductPublicDto) => {
  const {
    pricingClientPublic
  } = useServicesStore.getState();
  const {
    quantity: startingQuantity
  } = usePdpParams();
  const selectedMaterial = usePdpStore(state => state.material);
  const material = selectedMaterial ?? product?.defaultMaterial;
  const request = product ? buildStartingPriceRequest(product, startingQuantity, material) : undefined;
  return useQuery<ItemPriceResultDto | undefined>({
    queryKey: ["starting-price", product?.sku, request?.item.quantity, material],
    enabled: Boolean(pricingClientPublic) && Boolean(request),
    queryFn: async () => {
      if (!pricingClientPublic || !request) {
        throw new Error("Pricing client is not available or pricing request is missing.");
      }
      return await pricingClientPublic.getPricingForItem(request);
    }
  });
};